import { inject, Injectable, Signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { User } from '@core/account-types';

import { UserSelectors } from './user.store';

@Injectable({ providedIn: 'root' })
export class UsersDataService {
  private readonly store = inject(Store);

  public getAllUsers(): Signal<User[]> {
    return this.store.selectSignal(UserSelectors.entities());
  }

  public getUsersByIds(ids: number[]): Signal<User[]> {
    return this.store.selectSignal(UserSelectors.byIds(ids));
  }

  public getUsersByRoles(roleIds: number[]): Signal<User[]> {
    return this.store.selectSignal(UserSelectors.byRoleIds(roleIds));
  }
}
